import { useState } from 'react';

export const useReportFilter = <T,>(onApply: (values: T) => void, defaults: T) => {
    const [show, setShow] = useState(false);
    const close = () => setShow(false);
    const apply = (values: T) => {
        onApply(values);
        close();
    };
    return { show, close, open: () => setShow(true), apply, reset: () => apply(defaults) };
};
